import { PropsWithChildren } from "react";

export const MenubarContainer = ({ children }: PropsWithChildren) => (
  <div className="flex flex-row gap-2 justify-between items-center grow-0">
    {children}
  </div>
);
